import { useEffect, useState } from "react";
import { APIHandlerSimulation } from "hooks/api-handler-simulation";
export function UseLazyApiCallSimulation({ url, method, paramsData }: any) {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>();

  async function getData(props: any) {
    const localData = props?.params || paramsData;
    const localUrl = props?.url || url;

    let apiResponseInitial = null;

    try {
      setIsLoading(true);
      const data: any = await APIHandlerSimulation({
        method,
        url: localUrl,
        data: localData,
      });

      setData(data);
      apiResponseInitial = data;
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
    return apiResponseInitial;
  }

  return [getData, { data, isLoading, error }];
}
